import { fixedAssets } from 'src/containers/PreCache'

import { onDemandVideosType } from './videos'
import routes from 'src/routes'

export interface onDemandCategoryType {
  id: number
  title: string
  categoryName?: string
  thumbnail: string
  profile?: string
  destination?: string
  embedUrl?: string
  videos?: Array<onDemandVideosType>
}

type PdfViewType = {
  id: string | number
  title: string
  thumbnail: string
  filePath: string
}
type VideoType = {
  id: string | number
  title: string
  thumbnail: string
  iframeUrl: string
}

type Day1Slides = PdfViewType
type Day2Slides = PdfViewType
type UpcomingEvents = PdfViewType

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 1,
    thumbnail: fixedAssets.videoIcon,
    title: 'Day 1 Videos',
    destination: routes.galleryDay1Videos,
  },
  {
    id: 2,
    thumbnail: fixedAssets.videoIcon,
    title: 'Day 2 Videos',
    destination: routes.galleryDay2Videos,
  },
  // {
  //   id: 3,
  //   thumbnail: fixedAssets.folderIcon,
  //   title: 'Day 1 Slides',
  //   destination: routes.onDemandDay1,
  // },
  {
    id: 4,
    thumbnail: fixedAssets.folderIcon,
    title: 'Day 2 Slides',
    destination: routes.onDemandDay2,
  },
  // {
  //   id: 5,
  //   thumbnail: fixedAssets.folderIcon,
  //   title: "Upcoming Events",
  //   destination: routes.onDemandUpcomingEvents,
  // },
]

const day1Slides: Day1Slides[] = [
  // {
  //   id: 4,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 5 - Mr Vijayen Nagalingham',
  //   filePath: '/gallery/day1/Topic 5 - Mr Vijayen Nagalingham.pdf',
  // },
  // {
  //   id: 5,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Mr. Jason Tan',
  //   filePath: '/gallery/day1/Topic 7 - Mr. Jason Tan.pdf',
  // },
  // {
  //   id: 6,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Mr. Shafudin',
  //   filePath: '/gallery/day1/Topic 7 - Mr. Shafudin.pdf',
  // },
  // {
  //   id: 7,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 7 - Ms. Margaret Lee',
  //   filePath: '/gallery/day1/Topic 7 - Ms. Margaret Lee.pdf',
  // },
  // {
  //   id: 8,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Topic 8 - Ms Zaleha Adam',
  //   filePath: '/gallery/day1/Topic 8 - Ms Zaleha Adam.pdf',
  // },
]

const day2Slides: Day2Slides[] = [
  {
    id: 1,
    thumbnail: fixedAssets.docIcon,
    title: 'Topic 5 - Taxation from Operation Perspective Today: What is Really Challenging Taxpayers in 2026',
    filePath: '/gallery/day2/Topic 5 - Mr Vijayen Nagalingham.pdf',
  },
  {
    id: 2,
    thumbnail: fixedAssets.docIcon,
    title: 'Topic 6 - The Future of Tax Incentives in Malaysia',
    filePath: '/gallery/day2/Topic 6 - Mr. Keegan Ong.pdf',
  },
  {
    id: 3,
    thumbnail: fixedAssets.docIcon,
    title: 'Topic 8 - Updates of Tax Cases',
    filePath: '/gallery/day2/Topic 8 - Updates of Tax Cases.pdf',
  },
]

const upcomingEvents: UpcomingEvents[] = [
  // {
  //   id: 1,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Latest Brochure',
  //   filePath: '/gallery/upcoming-events/Latest Brochure.pdf',
  // },
  // {
  //   id: 2,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Preparing a Defense Ready Transfer Pricing TP Documentation which Complies with TP Rules 2023',
  //   filePath: '/gallery/upcoming-events/Preparing a Defense Ready Transfer Pricing TP Documentation which Complies with TP Rules 2023.pdf',
  // },
  // {
  //   id: 3,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Staying Ahead of the Latest Tax Developments and Issues in Malaysia',
  //   filePath: '/gallery/upcoming-events/Staying Ahead of the Latest Tax Developments and Issues in Malaysia.pdf',
  // },
  // {
  //   id: 4,
  //   thumbnail: fixedAssets.docIcon,
  //   title: 'Towards Readiness for Employers and Payroll Audit',
  //   filePath: '/gallery/upcoming-events/Towards Readiness for Employers and Payroll Audit.pdf',
  // },
]
const day1Videos: VideoType[] = [
  {
    id: 'Opening Ceremony',
    thumbnail: fixedAssets.videoIcon,
    title: 'Opening Ceremony',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/2181570c-b91d-49fc-897c-6efa66c39bfc',
  },
  {
    id: 'Topic 1',
    thumbnail: fixedAssets.videoIcon,
    title: "Topic 1 - Advancing Voluntary Compliance: HASIL's Initiatives to Foster Trust, Transparency and Taxpayer Engagement",
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/1af3bbdf-a1ee-43c0-9ce1-0dce7b0daca0',
  },
  {
    id: 'Topic 2',
    thumbnail: fixedAssets.videoIcon,
    title: "Topic 2 - Mid-Term Tax Policy Review: Status of Implementation of Previous Tax Proposals, What's on the Horizon",
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/295dde05-6c53-4617-8d30-11b71584f126',
  },
  {
    id: 'Topic 3',
    thumbnail: fixedAssets.videoIcon,
    title: 'Topic 3 - What Global Uncertainty Means for Malaysia: Economic, Market, and Business Implications',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/63156a1e-c4c1-4e5a-ab97-e238f0108571',
  },
  {
    id: 'Topic 4',
    thumbnail: fixedAssets.videoIcon,
    title: "Topic 4 - Global Trends in Taxation: What's Happening Around the World?",
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/d27c1215-a983-417d-82b5-6faf94504fd0',
  },
]

const day2Videos: VideoType[] = [
  // {
  //   id: 'Overview of Day 1',
  //   thumbnail: fixedAssets.videoIcon,
  //   title: 'Overview of Day 1',
  //   iframeUrl: 'https://drive.google.com/file/d/17eYGfbZ7IUsop99239DNI71ZYZB-lhHK/view',
  // },
  {
    id: 'Topic 5',
    thumbnail: fixedAssets.videoIcon,
    title: 'Topic 5 - Taxation from Operations Perspective Today: What is Really Challenging Taxpayers in 2026',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/ba4e1b1c-6f2e-491a-a973-993b2b664026',
  },
  {
    id: 'Topic 6',
    thumbnail: fixedAssets.videoIcon,
    title: 'Topic 6 - The Future of Tax Incentives in Malaysia',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/0c0c6109-912c-4a0c-bb14-0580ebf5c0d7',
  },
  {
    id: 'Topic 7',
    thumbnail: fixedAssets.videoIcon,
    title: 'Topic 7 - Rethinking Stamp Duty: Lessons from Practice, Systems and Global or Regional Experience',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/eeb66f2d-171f-45ab-a26f-2e3ea5adedbb',
  },
  {
    id: 'Topic 8 ',
    thumbnail: fixedAssets.videoIcon,
    title: 'Topic 8 - Updates of Tax Cases',
    iframeUrl: 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/630bfa98-3e42-4ee3-9153-e403ccc1c703',
  },
]

export { onDemandCategories, day1Slides, day2Slides, upcomingEvents, day1Videos, day2Videos }
